import React from 'react';
import Badge from '@/components/Badge';
import { Body } from '@/components/Typography';
import { ViolationDisplayStatus } from '@/types/accountability';

export const getDisplayStatusBadge = (status: ViolationDisplayStatus) => {
  const statusMap: Record<
    ViolationDisplayStatus,
    { label: string; status: 'warning' | 'success' | 'neutral' | 'danger' }
  > = {
    needs_review: { label: 'Needs Review', status: 'warning' },
    open: { label: 'Open', status: 'success' },
    upheld: { label: 'Upheld', status: 'neutral' },
    cleared: { label: 'Cleared', status: 'neutral' },
  };
  const config = statusMap[status] || { label: status, status: 'neutral' };
  return <Badge label={config.label} status={config.status} />;
};

export const getViolationTypeLabel = (type: string) => {
  return <Body>{type === 'late_drop' ? 'Late Drop' : 'No Show'}</Body>;
};

export const getViolationTypeBadge = (type: string) => {
  return type === 'late_drop' ? (
    <Badge label="Late Drop" status="warning" />
  ) : (
    <Badge label="No Show" status="danger" />
  );
};
